import { bankServices } from "../../config/axios";
import {
    WITHDRAWEMONEYLIST_SUCCESS,
    WITHDRAWEMONEYLIST_FAILED,
    RESET_WITHDRAWEMONEYLIST,
    LOADING_WITHDRAWEMONEYLIST,
    WITHDRAWEMONEYLIST_NETWORKERROR,
} from '../types/index';

const resetwithdrawEMoneyList = () => {
    return { type: RESET_WITHDRAWEMONEYLIST };
};

const withdrawEMoneyList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_WITHDRAWEMONEYLIST });
    await bankServices
        .post("widthdrawemoneylist", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: WITHDRAWEMONEYLIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: WITHDRAWEMONEYLIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: WITHDRAWEMONEYLIST_FAILED,
        payload: data
    };
}

export { resetwithdrawEMoneyList, withdrawEMoneyList }